import { useState } from "react";
import PropTypes from "prop-types";

import { alignItems, strCode } from "../../../../../consts";
import { t } from "../../../../../services";

import {
  FlexContainers,
  Modal,
  Paragraph2,
  SmallButton,
  WrapperContainer
} from "../../../../../components";
import { ButtonsWrapper, DeleteUserConfirmationWrapper } from "./styled";
import { FormButton } from "../../styled";

export const DeleteUser = ({ email, isAdminUser, onDelete, onResetPassword }) => {
  const [deleteModalActive, setDeleteModalActive] = useState(false);
  const [resetPasswordModalActive, setResetPasswordModalActive] = useState(false);

  return (
    <>
      <WrapperContainer width={"fit-content"} mt={16}>
        <ButtonsWrapper
          Container={FlexContainers.FlexRowStart}
          alignItems={alignItems.start}
          gap={16}>
          <FormButton secondary red onClick={() => setDeleteModalActive(true)}>
            {t(strCode.REMOVE_USER_BTN)}
          </FormButton>{" "}
          {!isAdminUser && (
            <FormButton secondary onClick={() => setResetPasswordModalActive(true)}>
              {t(strCode.RESET_USERS_PASSWORD_BTN)}
            </FormButton>
          )}
        </ButtonsWrapper>
      </WrapperContainer>

      <Modal
        id="delete-user-modal"
        title={t(strCode.DELETE_USER_CONFIRMATION_TITLE)}
        active={deleteModalActive}
        setActive={setDeleteModalActive}
        closable>
        <DeleteUserConfirmationWrapper>
          <Paragraph2
            dangerouslySetInnerHTML={{
              __html: t(strCode.DELETE_USER_CONFIRMATION_TEXT, { email })
            }}
          />

          <WrapperContainer Container={FlexContainers.FlexRowEnd} width={"100%"} gap={8} mt={16}>
            <SmallButton secondary secondaryBold onClick={() => setDeleteModalActive(false)}>
              {t(strCode.CANCEL_BTN)}
            </SmallButton>
            <SmallButton
              backgroundRed
              onClick={() => {
                setDeleteModalActive(false);
                onDelete();
              }}>
              {t(strCode.DELETE_BTN)}
            </SmallButton>
          </WrapperContainer>
        </DeleteUserConfirmationWrapper>
      </Modal>

      <Modal
        id="reset-user-password-modal"
        title={t(strCode.RESET_USERS_PASSWORD_CONFIRMATION_TITLE)}
        active={resetPasswordModalActive}
        setActive={setResetPasswordModalActive}
        closable>
        <DeleteUserConfirmationWrapper>
          <Paragraph2
            dangerouslySetInnerHTML={{
              __html: t(strCode.RESET_USERS_PASSWORD_CONFIRMATION_TEXT, { email })
            }}
          />

          <WrapperContainer Container={FlexContainers.FlexRowEnd} width={"100%"} gap={8} mt={16}>
            <SmallButton secondary secondaryBold onClick={() => setResetPasswordModalActive(false)}>
              {t(strCode.CANCEL_BTN)}
            </SmallButton>

            <SmallButton
              backgroundRed
              onClick={() => {
                setResetPasswordModalActive(false);
                onResetPassword();
              }}>
              {t(strCode.RESET_BTN)}
            </SmallButton>
          </WrapperContainer>
        </DeleteUserConfirmationWrapper>
      </Modal>
    </>
  );
};

DeleteUser.propTypes = {
  email: PropTypes.string.isRequired,
  isAdminUser: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  onResetPassword: PropTypes.func
};
